import { createGlobalStyle } from 'styled-components';
import { spacing, misc } from './utilities/settings';
import { below } from './utilities/mediaQueries';
import { richTextContent } from './utilities/elements';

const GlobalStyle = createGlobalStyle`
  #root {
    margin: 50px 0;

    main {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      justify-content: space-between;
      padding-top: ${spacing.headerHeight};

      ${below.ipadPort`
        padding-top: ${spacing.headerMobile};
      `}

      &.alert {
        padding-top: ${spacing.headerAlert};
      }

      section {
        margin-bottom: ${misc.sectionMargin}px;

        ${below.ipadPort`
          margin-bottom: ${misc.sectionMobileMargin}px;
        `}
      }
    }

    .skip-link {
      &:focus {
        z-index: 9999 !important;
      }
    }

    .body-content {
      ${richTextContent};
      width: 100%;
      overflow-x: hidden;
    }


    strong {
      font-weight: bold;
    }

    ol, ul {
      list-style: none;
      padding: 0;
    }

    blockquote, q {
      quotes: none;
    }

    blockquote:before, blockquote:after,
    q:before, q:after {
      content: '';
      content: none;
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    a {
      text-decoration: none;
    }

    img {
      height: auto;
      width: 100%;
    }

    .slick-list {
      transition-duration: ${misc.animSpeed};
    }

    .slick-dots {
      margin: 0 !important;
    }

    ${richTextContent};
  }
`;

export default GlobalStyle;
